<template lang="pug">
  v-select(
    v-model="p_code"
    :items="masterList"
    item-text="label"
    :item-value="itemValue"
    :label="labelDisp"
    :small-chips="useFilter"
    :multiple="useFilter"
    :clearable="clearable"
    :error-messages="errorHandlerMethod(errorHandlerMethodArgComputed)")
</template>

<script>
import * as Enum from "@/assets/js/enum";

export default {
  props: {
    // TODO:type:Boolean 必須でありながらNullがはいる可能性があるため回避。（※clearable影響）
    // eslint-disable-next-line vue/require-prop-types
    code: {
      required: true
    },
    errorHandlerMethod: {
      type: Function,
      default() {
        return null;
      }
    },
    errorHandlerMethodArg: {
      type: String,
      default() {
        return null;
      }
    },
    useFilter: {
      type: Boolean,
      default() {
        return false;
      }
    },
    labelDisp: {
      type: String,
      default: "支払状態"
    },
    clearable: {
      type: Boolean,
      default() {
        return false;
      }
    },
    filterPending: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      defaultErrorHandlerMethodArg: "status"
    };
  },
  computed: {
    p_code: {
      get() {
        return this.code;
      },
      set(newVal) {
        if (this.code !== newVal) this.$emit("update:code", newVal);
      },
      required: true
    },
    masterList: {
      get() {
        if (this.filterPending) {
          return Enum.Utils.enumToList(Enum.BillingStatusType).filter(
            value => value.code !== Enum.PaymentStatusType.PENDING.code
          );
        } else {
          return Enum.Utils.enumToList(Enum.PaymentStatusType);
        }
      }
    },
    errorHandlerMethodArgComputed: {
      get() {
        if (this.errorHandlerMethodArg == null) {
          return this.defaultErrorHandlerMethodArg;
        }
        return this.errorHandlerMethodArg;
      }
    },
    itemValue: {
      get() {
        if (this.useFilter) {
          return "label";
        } else {
          return "code";
        }
      }
    }
  },
  methods: {}
};
</script>
